import React from 'react';
import { ICONS } from 'Components/utils/icon/icons';
import { classnames } from 'Utils/classnames/classnames.utils';
import { Icon } from 'Components/frameworks/icon/Icon';
export type ECBadgeProps = {
  alt?: string;
  className?: string;
  size?: string;
};
export const ECBadge = ({ alt, className, size }: Props) => (
  <Icon
    alt={alt}
    className={classnames('text-white', className)}
    dataTestid="ECBadge"
    name={ICONS.EXCLUSIVE_COLLECTION}
    width={size}
  />
);
